module.exports = "<form class=\"som-forms description\">\n    <textarea\n        ng-model=\"IssueUserFormJournalCtrl.userNote\"\n        class=\"user-opinion full-width\"\n        placeholder=\"Masz uwagi dotyczące tego zgłoszenia?\"\n    ></textarea>\n    <button\n        class=\"btn-standard user-opinion\"\n        ng-click=\"IssueUserFormJournalCtrl.sendUserNote(item.id)\"\n    >\n        Wyślij do nas wiadomość\n    </button>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/housing_association_issue_list/journal/journal.html
// module id = 634
// module chunks = 0